import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import Menu from '../panel/Menu';
import moment from 'moment';

function Dashboard() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });

    const [userData, setUserData] = useState();
    const [bookedrooms, setbookedrooms] = useState(0);
    const [availablerooms, setavailablerooms] = useState(0);
    const [cleaningrooms, setcleaningrooms] = useState(0);
    const [allrooms, setallrooms] = useState(0);

    const [todayCount, settodayCount] = useState(0);
    const [tommCount, settommCount] = useState(0);
    const [thisMonth, setthisMonth] = useState(0);
    const [nextMonth, setnextMonth] = useState(0);

    const [todayCount1, settodayCount1] = useState(0);
    const [tommCount1, settommCount1] = useState(0);
    const [thisMonth1, setthisMonth1] = useState(0);
    const [nextMonth1, setnextMonth1] = useState(0);

    const [whatsappCount, setwhatsappCount] = useState(0);
    const [countPaid, setcountPaid] = useState(0);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData1();
        });
    }, [userData]);

    const fetchData1 = async () => {
        try {
            if (!userData) return;

            const today = moment().format('YYYY-MM-DD');
            const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
            const firstDateOfMonth = moment().startOf('month').format('YYYY-MM-DD');
            const lastDateOfMonth = moment().endOf('month').format('YYYY-MM-DD');
            const firstDayOfNextMonth = moment().add(1, 'months').startOf('month').format('YYYY-MM-DD');
            const lastDayOfNextMonth = moment().add(1, 'months').endOf('month').format('YYYY-MM-DD');

            const queries = [
                query(collection(db, 'roomdetails')),
                query(collection(db, 'roomdetails'), where('status', '==', 'Booked')),
                query(collection(db, 'roomdetails'), where('status', '==', 'Available')),
                query(collection(db, 'roomdetails'), where('status', '==', 'Cleaning')),
                query(collection(db, 'websitebookings'), where('checkindate', '==', today), where('status', '==', 'Paid')),
                query(collection(db, 'websitebookings'), where('checkindate', '==', tomorrow), where('status', '==', 'Paid')),
                query(collection(db, 'websitebookings'), where('checkindate', '>=', firstDateOfMonth), where('checkindate', '<=', lastDateOfMonth), where('status', '==', 'Paid')),
                query(collection(db, 'websitebookings'), where('checkindate', '>=', firstDayOfNextMonth), where('checkindate', '<=', lastDayOfNextMonth), where('status', '==', 'Paid')),
                query(collection(db, 'advancebookings'), where('checkindate', '==', today), where('status', '==', 'Paid')),
                query(collection(db, 'advancebookings'), where('checkindate', '==', tomorrow), where('status', '==', 'Paid')),
                query(collection(db, 'advancebookings'), where('checkindate', '>=', firstDateOfMonth), where('checkindate', '<=', lastDateOfMonth), where('status', '==', 'Paid')),
                query(collection(db, 'advancebookings'), where('checkindate', '>=', firstDayOfNextMonth), where('checkindate', '<=', lastDayOfNextMonth), where('status', '==', 'Paid')),
                query(collection(db, 'whatsapphistory'))
            ];

            const snapshots = await Promise.all(queries.map(q => getDocs(q)));

            setallrooms(snapshots[0].size);
            setbookedrooms(snapshots[1].size);
            setavailablerooms(snapshots[2].size);
            setcleaningrooms(snapshots[3].size);
            settodayCount(snapshots[4].size);
            settommCount(snapshots[5].size);
            setthisMonth(snapshots[6].size);
            setnextMonth(snapshots[7].size);
            settodayCount1(snapshots[8].size);
            settommCount1(snapshots[9].size);
            setthisMonth1(snapshots[10].size);
            setnextMonth1(snapshots[11].size);
            setwhatsappCount(snapshots[12].size);

            const querySnapshot = await getDocs(collection(db, 'whatsapp'));
            if (!querySnapshot.empty) {
                setcountPaid(querySnapshot.docs[0].data().countpaid);
            }
        } catch (error) {
            Toast.fire({ icon: 'error', title: error.message });
            console.error(error);
        }
    };

    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#f0f2f5' }}>
                <section className="content"><br />
                    <div className="container-fluid">
                        <h3>
                            || Dashboard ||
                        </h3>
                        <br /><br />
                        <div className="row">
                            <div className="col-lg-3 col-6">
                                <div className="small-box" style={{ backgroundColor: '#FF6B81', color: '#fff' }}>
                                    <div className="inner">
                                        <h3>{todayCount + todayCount1}</h3>
                                        <p>Today's Bookings</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-users" />
                                    </div>
                                    <a href="online-bookings/todays" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>

                            <div className="col-lg-3 col-6">
                                <div className="small-box" style={{ backgroundColor: '#FFA500', color: '#fff' }}>
                                    <div className="inner">
                                        <h3>{tommCount + tommCount1}</h3>
                                        <p>Tomorrow's Bookings</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-users" />
                                    </div>
                                    <a href="online-bookings/tommorrows" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>

                            <div className="col-lg-3 col-6">
                                <div className="small-box" style={{ backgroundColor: '#9B59B6', color: '#fff' }}>
                                    <div className="inner">
                                        <h3>{thisMonth + thisMonth1}</h3>
                                        <p>This Month Bookings</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-users" />
                                    </div>
                                    <a href="online-bookings/thismonth" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>

                            <div className="col-lg-3 col-6">
                                <div className="small-box" style={{ backgroundColor: '#3498DB', color: '#fff' }}>
                                    <div className="inner">
                                        <h3>{nextMonth + nextMonth1}</h3>
                                        <p>Next Month Bookings</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-users" />
                                    </div>
                                    <a href="online-bookings/nextmonth" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>

                            <div className="col-lg-3 col-6 mt-3">
                                <div className="small-box" style={{ backgroundColor: '#7F8C8D', color: '#fff' }}>
                                    <div className="inner">
                                        <h3>{whatsappCount - countPaid}</h3>
                                        <p>Wallet</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-wallet" />
                                    </div>
                                    <a href="wallet" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-lg-3 col-6">
                                <div className="small-box" style={{ backgroundColor: '#E74C3C', color: '#fff' }}>
                                    <div className="inner">
                                        <h3>{bookedrooms}</h3>
                                        <p>Live Booking Rooms</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-person-add"></i>
                                    </div>
                                    <a href="live-booking-rooms" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>

                            <div className="col-lg-3 col-6">
                                <div className="small-box" style={{ backgroundColor: '#2ECC71', color: '#fff' }}>
                                    <div className="inner">
                                        <h3>{availablerooms}</h3>
                                        <p>Available Rooms</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-person-add"></i>
                                    </div>
                                    <a href="available-rooms" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>

                            <div className="col-lg-3 col-6">
                                <div className="small-box" style={{ backgroundColor: '#F1C40F', color: '#fff' }}>
                                    <div className="inner">
                                        <h3>{cleaningrooms}</h3>
                                        <p>Cleaning Rooms</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-person-add"></i>
                                    </div>
                                    <a href="cleaning-rooms" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>

                            <div className="col-lg-3 col-6">
                                <div className="small-box" style={{ backgroundColor: '#1ABC9C', color: '#fff' }}>
                                    <div className="inner">
                                        <h3>{allrooms}</h3>
                                        <p>All Rooms</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-person-add"></i>
                                    </div>
                                    <a href="all-rooms" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Dashboard;
